import { createFormHook, useSelector } from '@tanstack/react-form'

import { AstraButton, AstraCallout } from '~/astra'

import { FormFloatingControl } from './FormFloatingControl'
import { fieldContext, formContext, useFormContext } from './formHookContexts'

const FormErrorCallout = () => {
    const form = useFormContext()
    return (
        <form.Subscribe selector={state => state.submissionAttempts > 0 && state.errors.length > 0}>
            {shouldShowError =>
                shouldShowError && <AstraCallout color="critical" text={'Skjemaet inneholder feil. Se over de markerte feltene og prøv igjen.'} />
            }
        </form.Subscribe>
    )
}

const FormSaveNewControl = ({ submitLabel = 'Legg til' }: { submitLabel?: string }) => {
    const form = useFormContext()

    const { showSubmitErrors, isSubmitting } = useSelector(form.store, state => ({
        showSubmitErrors: state.submissionAttempts > 0 && state.errors.length > 0,
        isSubmitting: state.isSubmitting,
    }))
    return (
        <div>
            {showSubmitErrors && <AstraCallout color="critical" text={'Noen felter er ugyldige. Se over de markerte feltene og prøv igjen.'} />}
            <div className="flex justify-end pt-4">
                <AstraButton variant="primary" label={submitLabel} onClick={() => form.handleSubmit()} isLoading={isSubmitting} disabled={isSubmitting} />
            </div>
        </div>
    )
}

export const { useAppForm, withFieldGroup, withForm } = createFormHook({
    fieldContext,
    formContext,
    fieldComponents: {},
    formComponents: {
        FormErrorCallout,
        FormFloatingControl,
        FormSaveNewControl,
    },
})
